/* Steelcraft theme scripts — vanilla, no dependencies */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.moneyFormat || 'Rs.{{amount}}';
    var value = (cents / 100);
    function withComma(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount': return withComma(value, 2);
        case 'amount_no_decimals': return withComma(Math.round(value), 0);
        case 'amount_with_comma_separator': return withComma(value, 2).replace(/,/g, '§').replace(/\./g, ',').replace(/§/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withComma(Math.round(value), 0).replace(/,/g, '.');
        default: return withComma(value, 2);
      }
    });
  }
  window.formatMoney = formatMoney;

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(message) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }
  window.themeToast = toast;

  /* ---------- overlay helpers ---------- */
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    var ov = $('#Overlay');
    if (ov) ov.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAllPanels() {
    $$('.mnav, .cart-drawer').forEach(function (p) { p.classList.remove('is-open'); });
    var ov = $('#Overlay');
    if (ov) ov.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.closeAllPanels = closeAllPanels;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open]');
    if (openBtn) {
      e.preventDefault();
      openPanel($('#' + openBtn.getAttribute('data-open')));
      return;
    }
    if (e.target.closest('[data-close-panel]') || e.target.id === 'Overlay') {
      closeAllPanels();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* ---------- announcement rotator ---------- */
  function initAnnounce() {
    var items = $$('.announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------- mobile nav accordions ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.mnav__toggle');
    if (!t) return;
    var sub = t.nextElementSibling;
    if (!sub) return;
    var open = sub.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- search toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var bar = $('#SearchBar');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) {
      var input = $('input[type="search"]', bar);
      if (input) input.focus();
    }
  });

  /* ---------- cart ---------- */
  function refreshCart() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer');
        var current = $('.cart-drawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
        var count = doc.querySelector('[data-cart-count-source]');
        $$('[data-cart-count]').forEach(function (el) {
          var n = count ? count.getAttribute('data-cart-count-source') : '0';
          el.textContent = n;
          el.style.display = (n === '0') ? 'none' : '';
        });
      });
  }
  window.refreshCart = refreshCart;

  function addToCart(payload, opts) {
    opts = opts || {};
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || err.message || 'Add to cart failed'); });
      return r.json();
    }).then(function (item) {
      return refreshCart().then(function () {
        if (!opts.silent) {
          if (opts.openDrawer !== false && $('.cart-drawer')) openPanel($('.cart-drawer'));
          else toast('Added to your cart');
        }
        return item;
      });
    });
  }
  window.addToCart = addToCart;

  /* Quick add on product cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-quick-add');
    btn.classList.add('is-loading');
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    addToCart({ items: [{ id: Number(id), quantity: 1 }] })
      .catch(function (err) { toast(err.message); })
      .then(function () { btn.classList.remove('is-loading'); btn.textContent = original; });
  });

  /* Cart line changes */
  function changeLine(key, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0);
      return;
    }
    var step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      var key = step.getAttribute('data-line-key');
      var next = Number(step.getAttribute('data-line-step'));
      changeLine(key, next);
      return;
    }
    var q = e.target.closest('[data-qty-step]');
    if (q) {
      e.preventDefault();
      var wrap = q.closest('.qty');
      var input = $('input', wrap);
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val += Number(q.getAttribute('data-qty-step'));
      if (val < 1) val = 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    var track = $('.gallery__track', root);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('.gallery__thumb', root);
    var counter = $('.gallery__counter', root);

    function setActive(i) {
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.min(i, slides.length - 1));
      });
    });

    setActive(0);

    root.addEventListener('gallery:go', function (e) {
      var i = e.detail.index;
      if (i < 0 || i >= slides.length) return;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    });
  }

  /* ---------- product form (variants, price, sticky, COD) ---------- */
  function initProduct(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var selected = {};
    var currentVariant = null;

    var priceNow = $('[data-price-now]', root);
    var priceWas = $('[data-price-was]', root);
    var priceSave = $('[data-price-save]', root);
    var addBtn = $('[data-add-btn]', root);
    var stockLine = $('[data-stock]', root);
    var idInputs = $$('[data-variant-id]', root);
    var qtyInput = $('[data-qty-input]', root);
    var gallery = $('.gallery', root);

    function findVariant() {
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === opt; });
      })[0] || null;
    }

    function updateUnavailable() {
      $$('[data-opt-index]', root).forEach(function (group) {
        var idx = Number(group.getAttribute('data-opt-index'));
        $$('.opt__pill', group).forEach(function (pill) {
          var candidate = Object.assign({}, selected);
          candidate[idx] = pill.getAttribute('data-value');
          var match = product.variants.filter(function (v) {
            return v.options.every(function (opt, i) {
              if (candidate[i] === undefined) return true;
              return candidate[i] === opt;
            });
          });
          var any = match.some(function (v) { return v.available; });
          pill.classList.toggle('is-unavailable', !any);
        });
      });
    }

    function render() {
      currentVariant = findVariant();
      idInputs.forEach(function (i) { i.value = currentVariant ? currentVariant.id : ''; });

      if (!currentVariant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (priceNow) priceNow.textContent = formatMoney(currentVariant.price);
      if (priceWas) {
        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
          priceWas.textContent = formatMoney(currentVariant.compare_at_price);
          priceWas.style.display = '';
          if (priceSave) {
            var pct = Math.round((1 - currentVariant.price / currentVariant.compare_at_price) * 100);
            priceSave.textContent = 'Save ' + pct + '%';
            priceSave.style.display = '';
          }
        } else {
          priceWas.style.display = 'none';
          if (priceSave) priceSave.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !currentVariant.available;
        addBtn.textContent = currentVariant.available ? addBtn.getAttribute('data-label-default') : 'Sold out';
      }

      if (stockLine) {
        if (!currentVariant.available) {
          stockLine.innerHTML = '<span class="dot dot--low"></span> Out of stock';
        } else if (currentVariant.inventory_management && currentVariant.inventory_quantity > 0 && currentVariant.inventory_quantity <= 5) {
          stockLine.innerHTML = '<span class="dot dot--low"></span> Only ' + currentVariant.inventory_quantity + ' left';
        } else {
          stockLine.innerHTML = '<span class="dot"></span> In stock — ready to dispatch';
        }
      }

      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(currentVariant.price);

      if (gallery && currentVariant.featured_media_index !== null && currentVariant.featured_media_index !== undefined) {
        gallery.dispatchEvent(new CustomEvent('gallery:go', { detail: { index: currentVariant.featured_media_index } }));
      }

      updateUnavailable();

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-opt-index]', root).forEach(function (group) {
      var idx = Number(group.getAttribute('data-opt-index'));
      var pre = $('.opt__pill.is-selected', group);
      selected[idx] = pre ? pre.getAttribute('data-value') : null;
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.opt__pill');
        if (!pill) return;
        $$('.opt__pill', group).forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        selected[idx] = pill.getAttribute('data-value');
        var label = $('[data-opt-selected]', group.closest('.opt'));
        if (label) label.textContent = pill.getAttribute('data-value');
        render();
      });
    });

    if (!product.options || product.options.length === 0) {
      currentVariant = product.variants[0];
    }
    render();

    /* Add to cart form */
    var form = $('[data-product-form]', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!currentVariant) return;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        addBtn.disabled = true;
        var label = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        addToCart({ items: [{ id: currentVariant.id, quantity: qty }] })
          .catch(function (err) { toast(err.message); })
          .then(function () { addBtn.disabled = false; addBtn.textContent = label; });
      });
    }

    /* Bundle tier quick-select */
    $$('[data-bundle-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (qtyInput) qtyInput.value = b.getAttribute('data-bundle-qty');
        toast('Quantity set to ' + b.getAttribute('data-bundle-qty'));
      });
    });

    /* COD express order */
    var cod = $('[data-cod-form]', root);
    if (cod) {
      cod.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = $('[data-cod-error]', cod);
        var name = $('[name="cod_name"]', cod).value.trim();
        var phone = $('[name="cod_phone"]', cod).value.trim();
        var address = $('[name="cod_address"]', cod).value.trim();
        var city = $('[name="cod_city"]', cod).value.trim();
        var digits = phone.replace(/\D/g, '');

        function fail(msg) {
          err.textContent = msg;
          err.classList.add('is-visible');
        }
        err.classList.remove('is-visible');

        if (name.length < 3) return fail('Please enter your full name.');
        if (digits.length < 10 || digits.length > 13) return fail('Please enter a valid mobile number, e.g. 03001234567.');
        if (city.length < 2) return fail('Please enter your city.');
        if (address.length < 10) return fail('Please enter a complete delivery address.');
        if (!currentVariant) return fail('Please choose an option above.');

        var btn = $('[data-cod-submit]', cod);
        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = 'Placing order…';

        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        addToCart({ items: [{ id: currentVariant.id, quantity: qty }] }, { silent: true })
          .then(function () {
            return fetch(window.routes.cart_update_url + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  'Order type': 'Cash on Delivery',
                  'Customer name': name,
                  'Mobile': phone,
                  'City': city,
                  'Delivery address': address
                }
              })
            });
          })
          .then(function () { window.location.href = window.routes.cart_url.replace('/cart', '') + '/checkout'; })
          .catch(function (e2) {
            fail(e2.message || 'Something went wrong. Please try again.');
            btn.disabled = false;
            btn.textContent = label;
          });
      });
    }
  }

  /* ---------- sticky add to cart ---------- */
  function initStickyAtc() {
    var bar = $('.sticky-atc');
    if (!bar) return;
    var anchor = $('[data-atc-anchor]');
    if (!anchor) return;
    document.body.classList.add('has-sticky-atc');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    io.observe(anchor);

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sticky-add]');
      if (!btn) return;
      var form = $('[data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- accordions ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.acc__btn');
    if (!btn) return;
    var panel = btn.nextElementSibling;
    var open = panel.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- boot ---------- */
  function boot() {
    initAnnounce();
    initReveal();
    $$('.gallery').forEach(initGallery);
    $$('[data-product-root]').forEach(initProduct);
    initStickyAtc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
